import { render, staticRenderFns } from "./SwiperModal.vue?vue&type=template&id=fa61a268&scoped=true&"
import script from "./SwiperModal.vue?vue&type=script&lang=js&"
export * from "./SwiperModal.vue?vue&type=script&lang=js&"
import style0 from "./SwiperModal.vue?vue&type=style&index=0&id=fa61a268&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa61a268",
  null
  
)

export default component.exports